
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'
import AdjustAmount from "./com/adjust-amount.vue";
import ChooseCoupon from "./com/choose-coupon.vue";
@Component({})
export default class extends ListViewVue {
  listType = "router";

  tablist = [
    {
      name: "全部用户",
      value: "",
    }
  ]

  activeName = ""

  /** el-table 多选选中的行，批量赠送优惠券用 */
  selectedRows: any[] = [];

  selectionChange(rows) {
    this.selectedRows = rows || [];
  }

  getGender(v) {
    switch (v) {
      case 1:
        return '男'
      case 2:
        return '女'
    }
    return '未知'
  }
  getCondition() {
    return {
      gender: "",
    }
  }

  gotoSearch(id?) {
    this.$goto(`/order/index?userId=${id}&type=0`);
  }


  gotoDetail(id) {
    this.$goto({ name: "customer-detail", query: { id: id } });
  }

  resetFilter() {
    this.find(this.getCondition())
  }

  async setLevel(row) {
    let levelData = await this.$chooseVipGroup({
      multiple: false,
    });
    let { error, message } = await this.$post("/manager/level/set-user-level", {
      levelId: levelData.id,
      id: row.id,
    });
    if (error) return this.$error(message);
    this.$success("操作成功");
    this.refresh();
  }

  async adjustAmount(row) {
    try {
      await this.$dialog({
        title: "调整用户金额",
        props: {
          width: "440px",
        },
        content: () => {
          return <AdjustAmount data={row}></AdjustAmount>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }
    this.$success("调整成功");
    this.refresh();
  }

  async sendCoupon() {
    if (!this.selectedRows.length) return;
    let userIds = this.selectedRows.map((row) => row.id);

    let coupon: any;
    try {
      coupon = await this.$dialog({
        title: "赠送优惠券",
        props: {
          width: "900px",
        },
        content: () => {
          return <ChooseCoupon userCount={userIds.length}></ChooseCoupon>;
        },
      });
    } catch (e) {
      // 用户取消
      return;
    }

    let { error, data, message } = await this.$post("/manager/coupon/send", {
      id: coupon.id,
      userIds,
    });
    if (error) return this.$error(message);

    if (!data.failCount) {
      this.$success(`赠送成功，共 ${data.successCount} 张`);
      return;
    }

    // 后端返回的失败只带 userId，用选中行的昵称/手机号拼成人能看的文案
    let nameMap = {};
    this.selectedRows.forEach((row) => {
      nameMap[row.id] = row.name || row.phone || `用户${row.id}`;
    });
    let failText = (data.failList || [])
      .map((item) => `${nameMap[item.id] || item.id}：${item.message}`)
      .join("\n");
    this.$success(`成功 ${data.successCount} 张，失败 ${data.failCount} 张`);
    this.$alert(failText);
  }

  async getList() {
    let data: any = { ...this.mesureData };
    // 兜一层：起止时间是日期字段，空值不能发出去（否则后端 400）
    ['startTime', 'endTime'].forEach((key) => {
      if (!data[key]) delete data[key];
    });
    return this.$post("/manager/user/list", data);
  }
}
